import type { MouseEventHandler } from 'react'

export interface PaginationDotsProps {
  'aria-label'?: string
  className?: string
  index: number
  onClick?: (index: number) => void
  pages: number
  progress?: number
  rtl?: boolean
  getDotAriaLabel?: (index: number) => string
  variant?: PaginationDotsVariantType
}

export enum PaginationDotsVariant {
  automatic = 'automatic',
  manual = 'manual',
}

export type PaginationDotsEdgeType = {
  first: number | undefined
  last: number | undefined
}

export type PaginationDotsIndex = {
  current : number
  previous: number | undefined
}

export interface PaginationDotProps {
  'aria-label': string 
  edge: boolean
  onClick: MouseEventHandler<HTMLButtonElement> | undefined
  rtl: boolean
  selected: boolean
  variant: PaginationDotsVariantType
  unselected: boolean
}

export type PaginationDotsVariantType = `${PaginationDotsVariant}`
